import { useEffect } from 'react';

const RESIZE_OBSERVER_NOISE_MESSAGES = [
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded',
];

const isResizeObserverNoise = (message) =>
  RESIZE_OBSERVER_NOISE_MESSAGES.some((candidate) => message.includes(candidate));

const useSuppressResizeObserverErrors = () => {
  useEffect(() => {
    const handleResizeObserverNoise = (event) => {
      const message = String(
        event?.message ||
        event?.error?.message ||
        event?.reason?.message ||
        ''
      );

      if (!isResizeObserverNoise(message)) {
        return;
      }

      event.preventDefault?.();
      event.stopImmediatePropagation?.();
    };

    window.addEventListener('error', handleResizeObserverNoise, true);

    return () => {
      window.removeEventListener('error', handleResizeObserverNoise, true);
    };
  }, []);
};

export default useSuppressResizeObserverErrors;
